import React from 'react';
import { useNavigate } from 'react-router-dom';
import PowerOutage from '../components/PowerOutage';

export default function PowerOutageScreen() {
    const navigate = useNavigate();
    return (
        <div className="p-4">
            <button
                onClick={() => navigate('/utilities')}
                className="mb-4 text-vietnam-primary hover:underline"
            >
                ← Quay lại
            </button>
            <PowerOutage />
        </div>
    );
}
